module.exports = __webpack_public_path__ + "img/tutorial2_3.57241170.png";